module.exports = __webpack_public_path__ + "static/media/form-back.2f907797.svg";